import { render, staticRenderFns } from "./BpTableHeader.vue?vue&type=template&id=321607bf&scoped=true&"
import script from "./BpTableHeader.vue?vue&type=script&lang=js&"
export * from "./BpTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./BpTableHeader.vue?vue&type=style&index=0&id=321607bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321607bf",
  null
  
)

export default component.exports